<template>
	<div>
		<div @click="showModal">
			<input-button :btn-class="'btn-grey'" class="btn-upload-companies">Upload companies <font-awesome-icon icon="upload" /></input-button>
		</div>

		<modal v-if="isModalVisible" @close="closeModal" @backgroundClicked="closeModal">
			<h2 slot="header">Upload Companies</h2>
			<div slot="body">
				<company-id-uploader @close="closeModal" @arrayChanged="updateUploadedFiles" :uploadedFiles="uploadedFiles" @showError="showError"></company-id-uploader>
			</div>
		</modal>

		<info-box v-if="isInfoBoxVisible" @close="closeInfoBox">
			<h2 slot="header">{{infoBoxHeader}}</h2>
			<div slot="body">{{infoBoxBody}}</div>
		</info-box>
	</div>	
</template>

<script>
	import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
	import InputButton from '../reusable/InputButton'
	import Modal from '../reusable/Modal'
	import CompanyIdUploader from '../reusable/CompanyIdUploader'	
	import InfoBox from '../reusable/InfoBox'

	export default {
		name: 'UploadCompanies',
		data() {
			return {
				isModalVisible: false,
				files: [],
				isInfoBoxVisible: false,
				infoBoxHeader: '',
				infoBoxBody: ''
			}
		},
		components: {
			FontAwesomeIcon,
			InputButton,
			Modal,
			CompanyIdUploader,
			InfoBox
		},
		methods: {
			showModal() {
				this.isModalVisible = true
			},
			closeModal() {
				this.isModalVisible = false;
			},
			updateUploadedFiles(val) {
				this.$emit('arrayChanged', val)
			},
			showError({ header, body }) {
				this.isInfoBoxVisible = true;
				this.infoBoxHeader = header;
				this.infoBoxBody = body;
			},
			closeInfoBox() {
				this.isInfoBoxVisible = false;
			}
		},
		props: ['uploadedFiles']
	}
</script>

<style lang="scss" scoped>
	button{
		width:100%;
	}
</style>
